<div class="custom-switch">
  <input type="checkbox" id="schedulePayment" class="switch-input" [(ngModel)]="switchValue" (ngModelChange)="changeSwitch()">
  <label for="schedulePayment" class="switch-label" [ngClass]="{'checked': switchValue}">
    <div class="checkmark">
      <span class="text-roboto yes-label" id="yesLabel" [style.color]="switchValue ? 'white' : 'inherit'" [style.opacity]="switchValue ? 1 : 0">{{ activeLabel }}</span>
      <span class="text-roboto no-label" id="noLabel" [style.color]="switchValue ? 'inherit' : 'black'" [style.opacity]="switchValue ? 0 : 1">{{ inactiveLabel }}</span>
    </div>
  </label>
  <span class="switch-handle" [style.transform]="switchValue ? 'translateX(30px)' : 'translateX(0)'"></span>
</div>
